import React, { Component } from "react";

import CuentaCompromisoSocio from "../../../generico/CuentaCompromisoSocio";
import SeleccionImportePago from "../SeleccionImportePago";
import PagoAporteService from "../../../../services/pagos/PagoAporteService";
import { trackPromise } from "react-promise-tracker";
import { splitImporte } from "../../../generico/utils/FormatoInput";
import AuthService from "../../../../services/login/auth.service";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faCheck, faArrowRight} from "@fortawesome/free-solid-svg-icons";

export default class AportePaso1 extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }
  initData = () => {
    this.resetState();
    this.getCuentas(this.TIPO_DEBITO);
    this.continuar.disabled = true;
  };
  resetState = () => {
    this.setState(this.getInitialState());
  };
  getInitialState = () => ({
    cuentasOrigen: [],
    ctaFullData: {},
    ctaOrigenSele: { value: "-1", label: "--Seleccione--" },
    importe: "0",
    deudaTotal: "",
    deudaHoy: "",
    moneda: "",
  });

  componentDidMount() {
    this.initData();
  }

  enableNext() {
    const { ctaOrigenSele } = this.state;
    const { importe } = this.state;
   
    if (
      ctaOrigenSele.value !== undefined &&
      ctaOrigenSele.value !== "-1" &&
      importe !== undefined &&
      importe.trim().length > 0 &&  splitImporte(importe)>0
    ) {
      this.continuar.disabled = false;
    } else {
      this.continuar.disabled = true;
    }
  }
  ctaOrigenValue = (ctaFullData, item) => {
    this.setState(
      { ctaFullData: ctaFullData, ctaOrigenSele: item },
      this.enableNext
    );
  };
  montoValue = (_monto) => {
    this.setState(
      {
        monto: _monto,
      },
      this.checkGrilla
    );
  };

  getCuentas() {
    trackPromise(
      PagoAporteService.pagosSeleccionados("AP").then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        if (jData.codigoRetorno === "0") {
          var usuario = AuthService.getCurrentUser();
          for (let i = 0; i < jData.resultadoPago.length; i++) {
            jData.resultadoPago[i].denominacion = usuario.nombreCompleto;
            
          }
          this.setState({
            cuentasOrigen: jData.resultadoPago,
            deudaHoy: jData.deudaFecha,
            deudaTotal: jData.deudaTotal,
            moneda: "GS",
          });
        }
      })
    );
  }

  returnImporte(_importe) {
    this.setState({ importe: _importe }, this.enableNext);
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text current">Datos de Pago</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="row justify-content-md-center">
              <div className="col-lg-7 col-md-10">
                <CuentaCompromisoSocio
                  renderMonto="false"
                  selectorValue={this.ctaOrigenValue.bind(this)}
                  montoValue={this.montoValue.bind(this)}
                  operacion="DEBITO"
                  tipoCuenta="AHORRO_VISTA"
                  items={this.state.cuentasOrigen}
                  itemSelected={this.state.ctaOrigenSele}
                  titleImporte="Ingrese el Importe a Pagar"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row justify-content-md-center">
          <div className="col-lg-7 col-md-10">
            <SeleccionImportePago
              importe={this.state.importe}
              deudaTotal={this.state.deudaTotal}
              deudaHoy={this.state.deudaHoy}
              moneda={this.state.moneda}
              tipoObligacion="APORTE"
              returnImporte={this.returnImporte.bind(this)}
            />
          </div>
        </div>

        <hr />

        <div className="row">
          <div className="col-md-10">
              <label
                className="input-label-bold-obligatorio float-left">
                (*) Campos Obligatorios
                <br />
              </label>
          </div>
          <div className="col-md-2">
              <button
                  ref={(button) => (this.continuar = button)}
                  className="btn btn-cu-primary"
                  onClick={() => {
                    const { importe } = this.state;
                    const { moneda } = this.state;
                    const { ctaFullData } = this.state;
                    this.props.returnDataPaso1(importe, ctaFullData, moneda);
                    this.nextStep.click();
                  }}>
                Continuar <FontAwesomeIcon icon={faArrowRight} />
              </button>
              <button hidden ref={(a) => (this.nextStep = a)} className="btn btn-cu-primary" onClick={this.props.nextStep}/>
          </div>
        </div>
      </div>
    );
  }
}
